<div 
    data-testid="contact-icon"
    class="rounded-circle contact-icon ms-1 mt-1 flex-shrink-0"
    [class]="cssClass()">{{ fullName() === 'Unknown' ? '?' : (fullName() | initials) }}</div>